//TODO : Refactor after ai
/**
 * Übersetzt einen Datensatz in den Deskriptor, den alle Darstellungen des
 * UI-Kits verstehen (Zeile, Tabelle, Tafel, Kalender). So ist ein Objekt in
 * jeder Ansicht wiedererkennbar.
 */

import type {
  ObjectAttribute,
  OverviewObject,
} from "@shared/components/widgets/ooux";
import {
  formatWert,
  statusFarbe,
  type Datensatz,
  type Feld,
  type ObjektKlasse,
} from "@shared/demo-data/viacid";

/** Die Angaben, die zwischen zwei Zeilen unterscheiden – ohne Kennung, Titel und Dateien. */
export function kernfelder(
  klasse: ObjektKlasse,
  satz: Datensatz,
  anzahl: number
): Feld[] {
  return klasse.felder
    .filter(
      (f) =>
        f.key !== klasse.kennungFeld &&
        f.typ !== "Datei" &&
        satz.werte[f.key] != null &&
        String(satz.werte[f.key]) !== satz.titel &&
        String(satz.werte[f.key]).length <= 60
    )
    .slice(0, anzahl);
}

export function angaben(
  klasse: ObjektKlasse,
  satz: Datensatz,
  anzahl: number
): ObjectAttribute[] {
  return kernfelder(klasse, satz, anzahl).map((f) => ({
    label: f.label,
    value: formatWert(f, satz.werte[f.key]),
  }));
}

/** Das erste Datumsfeld – damit landet der Datensatz im Kalender. */
export function terminFeld(klasse: ObjektKlasse): Feld | undefined {
  return klasse.felder.find((f) => f.typ === "Datum");
}

export function alsUebersichtsObjekt(
  klasse: ObjektKlasse,
  satz: Datensatz
): OverviewObject {
  const termin = terminFeld(klasse);
  const datum = termin ? satz.werte[termin.key] : undefined;
  return {
    id: satz.id,
    type: klasse.name,
    identifier: satz.kennung ?? undefined,
    title: satz.titel,
    subtitle: satz.untertitel ?? undefined,
    status: satz.status ?? undefined,
    statusColor: statusFarbe(klasse, satz.status),
    group: satz.status ?? undefined,
    date: typeof datum === "string" ? datum.slice(0, 10) : undefined,
    attributes: angaben(klasse, satz, 3),
  };
}
